<template lang="pug">
div
  .mt-8
    .text-xl.font-semibold.mb-3 Match column labels to customers information
    .mb-10
      span.font-bold {{ data.total_column }} 
      span {{ data.total_column > 1 ? 'columns' : 'column' }} have been recognized in this file

    v-data-table(:headers="headers" :items="items" :items-per-page="items.length" hide-default-footer disable-sort)
      template(v-slot:no-data)
        div
      template(v-slot:header.checked)
        yc-checkbox(v-model="checkAll" @change="onCheckedAll")
      template(v-slot:item.checked="{ item }")
        yc-checkbox(v-model="item.checked" @change="onChecked")
      template(v-slot:item.field="{ item }")
        .my-2
          custom-field-dropdown(:field.sync="item.field" :selectedFields="selectedFields")
      template(v-slot:item.type="{ item }")
        .my-2
          type-field-dropdown(:dataType="item.field && item.field.datatype" :dateFormat.sync="item.dateFormat" :disabled="isTypeDisabled(item)")
    .text-right.mt-4
      v-btn.button-md(@click="finishMapping" color="info" depressed :loading="isLoading" :disabled="isUncheckedAll") Finish mapping
      
  .dialogs
    y-dialog(v-if="showMapAllDialog" v-model="showMapAllDialog" max-width=568 fluid scrollable content-class="round-2xl")
      v-card
        v-card-text.pa-8.primary--text
          .text-xl.font-medium.mb-4 Please map all of the column that you want to import 
          .text-md You can choose to map it to a new field or an existing one.
        v-divider
        v-card-actions.px-6.py-3
          v-spacer
          v-btn.button-md(@click="showMapAllDialog = false" color="info" depressed) Continue mapping
    y-dialog(v-if="showConfirmMappingDialog" v-model="showConfirmMappingDialog" max-width=568 fluid scrollable content-class="round-2xl")
      v-card
        v-card-text.pa-8.primary--text
          .text-xl.font-medium.mb-4 {{ checkedCount }} {{ checkedCount > 1 ? 'columns' : 'column' }}  will be imported. Another {{ totalCount - checkedCount }} columns will not be imported
          .text-md Are you sure you want to proceed?
        v-divider
        v-card-actions.px-6.py-3
          v-spacer
          v-btn.button-md.neutral500--text(@click="showConfirmMappingDialog = false" depressed text) No, I want to make changes
          v-btn.button-md.white--text(@click="submitData" color="danger500" depressed) Yes, continue
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CustomFieldDropdown from './CustomFieldDropdown.vue'
import TypeFieldDropdown from './TypeFieldDropdown.vue'

export default {
  components: {
    CustomFieldDropdown, 
    TypeFieldDropdown
  },
  props: ['data', 'inputFile', 'type', 'os'],
  data: () => ({
    checkAll: true,
    showMapAllDialog: false,
    showConfirmMappingDialog: false,
    isLoading: false,
    checkedCount: 0,
    totalCount: 0,
    headers: [
      { text: '', value: 'checked' },
      { text: 'Column', value: 'column' },
      { text: 'Sample Data', value: 'sample' },
      { text: 'Yezza Field', value: 'field' },
      { text: 'Type', value: 'type' }
    ],
    backgroundCheckingInterval: null,
    currentFormData: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    isUncheckedAll () {
      let uncheckedAll = true
      this.items.map(item => {
        if (item.checked) {
          uncheckedAll = false
        }
      })
      return uncheckedAll
    },
    selectedFields () {
      return this.items.filter(i => i.field).map(item => `${item.field.id}`)
    },
    items () {
      const fields = []
      if (this.data) {
        this.data.data.forEach(item => {
          const info = {
            checked: true,
            column: item[0],
            sample: item[1],
            field: null,
            type: null
          }
          fields.push(info)
        })
      }
      return fields
    },
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    }
  },
  created () {
    this.headers.map(item => item['class'] = 'text-table-header')
  },
  methods: {
    ...mapActions(['showMessage']),
    isTypeDisabled (item) {
      return item.field?.datatype !== 'date'
    },
    onCheckedAll (value) {
      this.items.map(item => item.checked = value)
    },
    onChecked (value) {
      if (!value) {
        this.checkAll = false
      }
    },
    finishMapping () {
      let isFieldEmpty = false
      this.items.map(item => {
        if (item.checked) {
          if (!item.field) {
            isFieldEmpty = true
          }
        }
      })
      if (isFieldEmpty) {
        this.showMapAllDialog = true
        return
      }
      const ids = this.items.filter(i => i.field).map(item => `${item.field.id}`.toLowerCase())
      if (ids.length !== new Set(ids).size) {
        this.showMessage(['error', 'Map only one field to a column'])
        return
      }

      this.checkedCount = this.items.filter(item => item.checked).length
      this.totalCount = this.items.length
      if (this.checkedCount !== this.totalCount) {
        this.showConfirmMappingDialog = true
      } else {
        this.submitData()
      }
    },
    isLargeFileSize (file) {
      const size = parseFloat(file.size / (1024 * 1024)).toFixed(2)
      return size > 1
    },
    submitData () {
      this.showConfirmMappingDialog = false
      this.currentFormData = null
      const formData = new FormData()
      formData.append('file', this.inputFile)
      formData.append('header_row_index', 0)
      const fields = []
      this.items.forEach((item, index) => {
        const mapperIndex = `mapper[${index}]`
        if (item.checked) {
          fields.push(item.field.id)
          formData.append(`${mapperIndex}id`, `${item.field.id}`.toUpperCase())
          if (item.field?.datatype === 'date') {
            let dateFormat = 'DD/MM/YYYY'
            if (item.dateFormat) {
              dateFormat = item.dateFormat
            }
            formData.append(`${mapperIndex}format`, dateFormat)
          }
        } else {
          formData.append(mapperIndex, '')
        }
      })
      if (!fields.includes('NAME')) {
        this.showMessage(['error', 'Name field is required'])
        return
      }
      if (!fields.includes('PHONE')) {
        this.showMessage(['error', 'Phone field is required'])
        return
      }
      this.isLoading = true
      this.currentFormData = formData
      if (this.isLargeFileSize(this.inputFile)) {
        this.$axios.post(`/connect/${this.company.slug}/${this.type}/import_csv/validate_in_background`, formData)
          .then(resp => {
            const processingId = resp.data.processing_id
            this.startCheckingBackgroundProcess(processingId)
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_import_csv')])
          })
      } else {
        this.$axios.post(`/connect/${this.company.slug}/${this.type}/import_csv/validate`, formData)
          .then(resp => {
            this.$emit('onMapping', formData)
            this.$emit('onValidate', resp.data)
          })
          .catch(e => {
            if (e.response?.data?.non_field_errors?.length > 0) {
              this.showMessage(['error', e.response.data.non_field_errors[0]])
            } else {
              this.showMessage(['error', this.$t('error_message.unable_to_import_csv')])
            }
          })
          .finally(() => {
            this.isLoading = false
          })
        }
    },
    startCheckingBackgroundProcess (id) {
      clearInterval(this.backgroundCheckingInterval)
      this.backgroundCheckingInterval = setInterval(() => {
        this.checkBackgroundProcessStatus(id)
      }, 5000)
    },
    checkBackgroundProcessStatus (processingId) {
      this.$axios.get(`/connect/${this.company.slug}/background_processings/${processingId}`)
        .then(resp => {
          const status = resp.data.status
          if (status == 'completed') {
            clearInterval(this.backgroundCheckingInterval)
            this.$emit('onMapping', this.currentFormData)
            this.$emit('onValidate', resp.data.result)
          } else if (status == 'error') {
            clearInterval(this.backgroundCheckingInterval)
            if (this.type === 'customers') {
              this.showMessage(['error', 'Unable to import customers.'])
            } else if (this.type === 'groups') {
              this.showMessage(['error', this.$t('error_message.unable_to_import_csv')])
            }
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          clearInterval(this.backgroundCheckingInterval)
        })
    },
  },
  destroyed () {
    clearInterval(this.backgroundCheckingInterval)
  }
}
</script>